/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { OSKEnvironment } from './models/environment.model';

export const environment: OSKEnvironment = {
  title: 'OSKEY (Development)',
  version: '0.1.0',
  production: true,
  defaultLocale: 'fr_FR',
  firebaseConfig: {
    apiKey: 'AIzaSyC6ri6aAQ-T7-ZkOs1fEL9lIW-uwDTq6ig',
    databaseURL: 'https://dev-oskey-io.firebaseio.com',
    authDomain: 'dev-oskey-io.firebaseapp.com',
    projectId: 'dev-oskey-io',
    storageBucket: 'dev-oskey-io.appspot.com',
    messagingSenderId: '243629143238',
    appId: '1:243629143238:web:ae3cb303a08634004a93c7',
    measurementId: 'G-DV65K9V6XZ'
  },
  reCaptcha: {
    siteCode: '6LdJZcsnAAAAAB4i64JlIPOxoLV2hkYHxPQX5mWv'
  },
  apple: {
    appBundleId: 'io.oskey.dev.app',
    appClipBundleIds: { acd: 'io.oskey.dev.app.AccessControlDevice' }
  },
  auth0: {
    domain: 'auth.dev.oskey.io',
    clientId: '0J6BUlCKPbGxTQcw661JmcfwYMpOyUqQ',
    organizationId: 'org_aDTctadWqOZ5zryI'
  }
};
